<apcam-error-page
    [title]="'shared.notFound.title' | translate"
    [message]="'shared.notFound.message' | translate">
    <a mat-stroked-button color="primary" [routerLink]="backRoute">
        {{ backLabel | translate }}
    </a>
</apcam-error-page>
